import React from 'react'
import { Grid, Flex } from 'components/Layout'
import { Text } from 'components/Typography'
import { SPACE } from 'Theme'

interface PrivateSessionPreviewProps {
  fullNames: string[]
}

export const PrivateSessionPreview: React.FC<PrivateSessionPreviewProps> = ({
  fullNames,
}) => (
  <Grid ml={{ MOBILE: 0, TABLET: SPACE.PX_40 }} gap={SPACE.PX_5}>
    <Flex justifyContent="flex-start" alignItems="center">
      <Text>{fullNames}</Text>
    </Flex>
  </Grid>
)
